module.exports = __webpack_public_path__ + "static/img/htyLogo.4bf6495.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/htyLogo.png
// module id = RLUQ
// module chunks = 18